import React, { useState, useEffect } from 'react'
import SelectWrapper from './select_wrapper'
import timeZones from '../data/us_state_county_time_zones.json' // Import JSON statically

interface USCountySelectProps {
    state: string
    label: string
    path: string
    required?: boolean
}

// Define the type for the JSON structure
interface CountyZone {
    County: string
    'Climate Zone': string
    'warm-humid?': string
}
interface TimeZoneData {
    [state: string]: CountyZone[]
}

const USCountySelectWrapper: React.FC<USCountySelectProps> = ({
    state,
    label,
    path,
    required,
}) => {
    const [counties, setCounties] = useState<string[]>([])

    useEffect(() => {
        if (state && (timeZones as TimeZoneData)[state]) {
            const stateData = (timeZones as TimeZoneData)[state]
            const countyNames = stateData.map(item => item.County)
            setCounties(countyNames)
        } else {
            setCounties([])
        }
    }, [state])

    return (
        <SelectWrapper
            options={counties}
            label={label}
            path={path}
            required={required}
        />
    )
}

export default USCountySelectWrapper
